import { LLM_WHISPERER_ENDPOINT, PRODUCT_NAMES } from "../llm-whisperer/helper";

const getUrl = (type, orgId) => {
  const url = "subscription/onboarding-status/";
  if (type === PRODUCT_NAMES.unstract) {
    return `/api/v1/unstract/${orgId}/${url}`;
  }

  if (type === PRODUCT_NAMES.llmWhisperer) {
    return `${LLM_WHISPERER_ENDPOINT}/${url}`;
  }

  return null;
};

const content = {
  unstract: {
    title: "Unstract Cloud",
    description:
      "A fully managed platform to eliminate manual processes involving unstructured documents using the power of LLMs.",
  },
  "llm-whisperer": {
    title: "LLMWhisperer",
    description:
      "LLMWhisperer is a technology that presents data from complex documents to LLMs in a way that they can best understand.",
  },
};

export { getUrl, content };
